import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { Modal } from "antd";
import { svg } from "../../../Assets/svg";
import { BtnLoader } from "../../../Components/Components";

const CommonRestoreModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleRestore: any;
  title: string;
  description: string;
  isLoading: boolean;
  setIsRestoreId?: React.Dispatch<React.SetStateAction<any>>;
  isLogo?: boolean;
  buttonName?: string;
}> = ({
  visible,
  setIsModalVisible,
  handleRestore,
  title,
  description,
  setIsRestoreId,
  isLoading,
  buttonName,
  isLogo = true,
}) => {
  const onClose = () => {
    setIsModalVisible(false);
    if (setIsRestoreId) {
      setIsRestoreId(null);
    }
  };
  return (
    <Modal
      title={""}
      visible={visible}
      onCancel={onClose}
      width={"30rem"}
      closeIcon={svg.modalClose}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isLoading}
            className="btn btn-lg btn-success"
            onClick={handleRestore}
          >
            {isLoading ? <BtnLoader /> : buttonName ? buttonName : "Restore"}
          </button>
        </div>
      }
      className="custom-modal"
    >
      <div className="modal-body page-form">
        {isLogo && (
          <div className="d-flex justify-content-center">
            {svg?.restoreTitleIcon}
          </div>
        )}
        <div className="fw-bold fs-4 d-flex justify-content-center mt-3 text-center">
          {title}
        </div>
        <p className="fs-6 d-flex justify-content-center mt-3 text-center">
          {description}
        </p>
      </div>
    </Modal>
  );
};

export default CommonRestoreModal;
